
import $ from "jquery"

import "bootstrap3-tooltip"
import "bootstrap3-popover"

import I18n from "plugins/i18n-js"
import * as Routes from "plugins/js-routes"

interface Selector {
  scope:          string | HTMLElement
  listings_ids:   string
  radio:          string
  form_container: string
  option_row:     string
  tooltip:        string | HTMLElement,
}
interface InputSelector {
  scope?:          string | HTMLElement
  listings_ids?:   string
  radio?:          string
  form_container?: string
  option_row?:     string
  tooltip?:        string | HTMLElement,
}
const DEFAULT_SELECTOR = {
  scope:          ".cell-new-development-contact-request-box",
  listings_ids:   ".cell-new-development-contact-request-box__contact-info__selectors",
  radio:          "input[name=\"listing_id\"]:radio",
  form_container: ".cell-new-development-contact-request-box__contact-form__container",
  option_row:     ".cell-new-development-contact-request-box__contact-info__option-row",
  tooltip:        ".cell--listing-contact-request-box--tooltip",
}

interface InputOptions {
  popover_options?: Bootstrap3Popover.Options,
}

const DEFAULT_POPOVER_OPTIONS = {
  placement:  "auto",
}

const init = (selector?: InputSelector, options?: InputOptions) => {
  const sele: Selector = Object.assign({}, DEFAULT_SELECTOR, selector)
  const $scope = $(sele.scope)

  const $listings_ids = $scope.find(sele.listings_ids)
  const $radio = $listings_ids.find(sele.radio)
  const $form_container = $scope.find(sele.form_container)
  const $option_row = $scope.find(sele.option_row)
  const $tooltip = $scope.find(sele.tooltip)

  $radio.on("change", ({target}) => {
    const input = target as HTMLInputElement

    $form_container
    .removeClass("active")    // Deactivate all items
    .filter(`.${input.value}`)
    .addClass("active")       // Activate only the selected one
    $option_row
    .removeClass("active")    // Deactivate all rows
    .filter(`.${input.value}`)
    .addClass("active")       // Activate only the selected one
  })

  const popover_options = Object.assign(
    {},
    DEFAULT_POPOVER_OPTIONS,
    options == null ? {} : options.popover_options,
    {
      container:  sele.scope,
      content:    I18n.t("concepts.listings.contact.request.box.sentences.tooltip_html",
                    {
                      privacy_link: Routes.privacy_policy_page_path({locale: I18n.locale}),
                    },
                  ),
      html:       "true",
    },
  )

  // add listener to each popup link
  $tooltip.each((idx, el) => {
    $(el).popover(popover_options)
  })

  $option_row.on("click", ({target}) => {
    // # Check the newly clicked radio button
    $(target).find(sele.radio)
    .prop("checked", true)
    .trigger("change")
  })
}

export default {init}
